module.exports = __webpack_public_path__ + "static/img/15.c347f71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/15.png
// module id = 5IA4
// module chunks = 0